import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const identityProviderAvailable = api(async function identityProviderAvailable({ clientId } = {}) {
    return await query(
        gql`
            query identityProviderAvailable($clientId: String) {
                identityProviderAvailable(clientId: $clientId)
            }
        `,
        { clientId },
        { returns: "identityProviderAvailable", fetchPolicy: "cache-first" }
    )
})
